export const INSTRUCTORS = { ken: 'Ken', bryn: 'Bryn', both: 'Ken & Bryn together', either: 'Either instructor' };
export const requestOwner = (instructor, assignee = '') => ['ken', 'bryn'].includes(instructor) ? instructor : assignee;
export const STATUSES = { new: 'New', invited: 'Booking link sent', closed: 'Closed', expired: 'Event ended' };
export const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
export const EMPTY_REQUEST = { name: '', email: '', kind: 'event', event_id: '', instructor: '', lesson_count: 1, partner_name: '', details: '', local_days: [], preferred_times: '', recurring_interest: false, source: 'In person', website: '' };

export function dateLabel(value) {
  if (!value) return '';
  return new Date(`${value.slice(0, 10)}T12:00:00Z`).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
}
export function eventLabel(event) {
  return `${event.name} · ${dateLabel(event.startDate)}–${dateLabel(event.endDate)}${event.location ? ` · ${event.location}` : ''}`;
}
const trackerDate = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit' });
export const localToday = () => trackerDate.format(new Date());
export const requestExpired = (request, today = localToday()) => request.kind === 'event' && Boolean(request.event_end) && request.event_end < today;
export const requestStatus = (request, today = localToday()) => requestExpired(request, today) ? 'expired' : request.status;
export function validCalendlyLink(value) {
  if (!value) return true;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && url.hostname === 'calendly.com' && !url.username && !url.password && !url.port && url.pathname.length > 1;
  } catch { return false; }
}
export function eventBookingAvailable(request, settings, host) {
  const hosts = host === 'both' ? ['ken', 'bryn'] : [host];
  return request.kind === 'event' && ['ken', 'bryn', 'both'].includes(host)
    && (request.instructor === host || (request.instructor === 'either' && host !== 'both'))
    && settings?.event_key === request.event_key
    && (!request.event_end || request.event_end >= localToday())
    && hosts.every(instructor => bookingLinkAvailable(settings, instructor));
}
export const bookingLinkAvailable = (settings, instructor) => Boolean(settings?.[`calendly_${instructor}`]?.trim()) && validCalendlyLink(settings[`calendly_${instructor}`]);
